<template>
  <div class="radio-list" :disabled="disabled">
    <inline-field-actions :schema="schema"></inline-field-actions>
    <div class="inline-fields">
      <div v-for="item in items" class="list-row">
        <label  class="input input--radio" :class="{'is-checked': isItemChecked(item)}">
          <input type="radio" class="input__default input__default--radio" :disabled="disabled" :name="id" @click="onSelection(item)" :value="getItemValue(item)" :checked="isItemChecked(item)">
          <div class="input__styled input__styled--radio"></div>
            {{ getItemName(item) }} <textarea class="form__inline-field" :value="getItemInputValue(item)" v-if="item.hasInputBox" @change="onInputBoxChanged($event, item)"></textarea>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import { mapMutations } from 'vuex';

  export default {
    /* eslint-disable no-throw-literal */
    /* eslint-disable max-len */
    mixins: [abstractField],

    computed: {
      items() {
        const values = this.schema.values;
        if (typeof (values) === 'function') {
          return values.apply(this, [this.model, this.schema]);
        }
        return values;
      },
      id() {
        return this.schema.model;
      },
    },

    methods: {
      ...mapMutations('admin', [
        'setFormChanged',
      ]),

      getItemValue(item) {
        if (item) {
          if (
            typeof this.schema.radiosOptions !== 'undefined'
            && typeof this.schema.radiosOptions.value !== 'undefined'
          ) {
            return item[this.schema.radiosOptions.value];
          }
          if (item.hasInputBox && item.value !== item.originalValue) {
            return `${item.originalValue}: ${item.value}`;
          }
          if (typeof item.value !== 'undefined') {
            return item.value;
          }
          throw '`value` is not defined. If you want to use another key name, add a `value` property under `radiosOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/radios.html#radios-field-with-object-values';
        } else {
          return item;
        }
      },

      getItemName(item) {
        if (item) {
          if (typeof this.schema.radiosOptions !== 'undefined' && typeof this.schema.radiosOptions.name !== 'undefined') {
            return item[this.schema.radiosOptions.name];
          }
          if (typeof item.name !== 'undefined') {
            return item.name;
          }
          throw '`name` is not defined. If you want to use another key name, add a `name` property under `radiosOptions` in the schema. https://icebob.gitbooks.io/vueformgenerator/content/fields/radios.html#radios-field-with-object-values';
        } else {
          return item;
        }
      },

      getItemInputValue(item) {
        return item.value !== item.originalValue ? item.value : '';
      },

      onSelection(item) {
        this.value = this.getItemValue(item);
        this.setFormChanged(true);
      },

      isItemChecked(item) {
        const currentValue = this.getItemValue(item);
        return (currentValue === this.value) || (this.model.dataRefs && this.model.dataRefs[this.schema.model] && this.model.dataRefs[this.schema.model].indexOf(item.ref) !== -1);
      },

      onInputBoxChanged(event, item) {
        item.value = event.target.value;
        this.value = this.getItemValue(item);
      },
    },
  };
</script>
